import { useTranslation } from "react-i18next"

import { useEvent } from "shared/lib/useEvent"

export function useDuplicationAffix() {
  const { t } = useTranslation()

  const addPrefix = useEvent(
    (title: string, prefix?: string) =>
      `${prefix || t("Duplicate.Affix")} ${title}`
  )

  const addSuffix = useEvent(
    (title: string, suffix?: string) =>
      `${title} ${suffix || t("Duplicate.Affix")}`
  )

  return {
    addPrefix,
    addSuffix
  }
}
